module.exports = __webpack_public_path__ + "static/media/GWE-PizzaBoxInstrESP.5996649d.pdf";